import LandingHeader from "../../components/layout/landingHeader";
import laptop from "../../assets/images/laptop.png";
import Differentiators from "../../assets/images/Differentiators.png";
import LandingFooter from "../../components/layout/landingFooter";
import cloudLeft from "../../assets/vector/Vector-8.png";
import cloudTop from "../../assets/vector/Vector-7.png";
import cloudFloat from "../../assets/vector/Vector-4.svg";

const MultiAssetPage = () => {
  return (
    <>
      <LandingHeader />

      <section className="hero-tech-mini hero-ryse-title arch-section">
        <div className="arch-bg">
          <img src={cloudTop} alt="" className="arch-cloud arch-cloud--top" />
        </div>

        <div className="hero-tech">
          <div className="hero-ryse__content mw-900">
            <h1 className="hero-ryse__headline w-none">
              The Multi-Asset Class Investment Platform
            </h1>
          </div>
        </div>
      </section>

      <section
        className="secure-arch arch-section vp-20  p-40-20"
        style={{ flexDirection: "column" }}
      >
        <div className="arch-bg">
          <img src={cloudLeft} alt="" className="arch-cloud arch-cloud--left" />
        </div>
 

        <div className="tech-arch__frame">
          <div className="secure-arch__inner">
            <div className="secure-arch__content">
              <h2 className="hero-ryse__headline">Benefits</h2>
            </div>

            <div className="img-left">
              <div className="secure-arch__image-wrapper">
                <img
                  src={laptop}
                  alt="Secure architecture"
                  className="secure-arch__image"
                />{" "}
              </div>
            </div>
          </div>
        </div>

        <div className="product-card bg-dark">
          <h3 className="text-square b">Portfolio 360° View</h3>
          <p className="text-square">
            Mix according to the types of underlying assets without relying on
            the manager reports. Tool supports all asset classes
          </p>

          <h3 className="text-square b">Portfolio Performance</h3>
          <p className="text-square">
            Identify the size and source of the performance
          </p>

          <h3 className="text-square b">Portfolio Risk</h3>
          <p className="text-square">
            Backward view on the aggregate size and decomposed view of risks to
            highlight the sources and drivers of risk
          </p>

          <h3 className="text-square b">Portfolio Forward View</h3>
          <p className="text-square">
            Forecasted size and source of risks under stressed market
            conditions, incorporating mitigation actions
          </p>

          <h3 className="text-square b">
            Forecasted size and source of risks under stressed market
            conditions, incorporating mitigation actions
          </h3>
          <p className="text-square">
            Of risk and returns at the portfolio, asset and manager level
          </p>

          <h3 className="text-square b">
            Custom Reporting, Dashboards & Drill-Down Analytics
          </h3>
          <p className="text-square">
            Multiple views for owners, portfolio mangers and risk management
          </p>
        </div>
      </section>

      <section
        className="secure-arch arch-section vp-20  p-40-20"
        style={{ flexDirection: "column" }}
      >
        <div className="arch-bg">
          <img
            src={cloudFloat}
            alt=""
            className="arch-cloud arch-cloud--left"
          />
        </div>

        <div className="tech-arch__frame">
          <div className="secure-arch__inner">
            <div className="hero-ryse__headline w-none">
              <p className="hero-ryse__headline">Differentiators</p>
              <br />
            </div>

            <div className="img-left">
              <div className="secure-arch__image-wrapper">
                <img
                  src={Differentiators}
                  alt="Secure architecture"
                  className="secure-arch__image"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="product-card bg-dark" style={{ marginBottom: "20px" }}>
          <h3 className="text-square b">
            Measure of Illiquid Investment Risk (e.g. real estate, private
            companies, MLPs, private partnerships, etc.) through a customized
            risk proxy{" "}
          </h3>

          <h3 className="text-square b">
            Risk Integration across liquid and illiquid investments
          </h3>

          <h3 className="text-square b">
            Forward-Looking Stress Testing Robust simulation of macroeconomic
            and market-driven shocks, including interest-rate scenarios and
            sector bubbles (e.g., tech).{" "}
          </h3>

          <h3 className="text-square b">
            Forward-Looking View of risk with stress testing of economic
            scenarios, e.g. interest rate or tech asset bubbles
          </h3>

          <h3 className="text-square b">
            Risk Sources and Exposure at the Portfolio and Asset Level e.g.
            inflation, commodities, etc.
          </h3>

          <h3 className="text-square b">
            Risk Mitigation/Simulation by integrating risk and reward
          </h3>

          <h3 className="text-square b">
            Portfolio Construction and Asset Allocation by integrating risk and
            reward
          </h3>
        </div>
      </section>
      <LandingFooter />
    </>
  );
};

export default MultiAssetPage;
